import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import EastIcon from "@mui/icons-material/East";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { CircularProgress } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { closeAllCarts } from "../../../../../../config/Services";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import "./ClosingHoldModal.css";
import useAuthModal from "../../../hooks/useAuthModal";
import HoldOrderDrawer from "../../../../posnavbar/components/HoldOrderDrawer";

const ClosingHoldModal = ({ setOpenHoldModal, navigate }) => {
  const { renderAuthModal, openAuthModal } = useAuthModal();
  const showSnackbar = useSnackbar();
  const [holdDrawerOpen, setHoldDrawerOpen] = useState(false);
  const { uidx } = JSON.parse(localStorage.getItem("retailUserDetails"));
  const locId = localStorage.getItem("locId");
  const licenseName = localStorage.getItem("licenseName");

  const { mutate: deleteHoldCarts, isLoading: isDeletingHoldCart } = useMutation({
    mutationFn: async (data) => {
      const response = await closeAllCarts(data);
      if (!!response?.data?.data?.es) {
        throw new Error(response?.data?.data?.message);
      }
      showSnackbar("Hold carts deleted successfully", "success");
      setOpenHoldModal(false);
      // navigate("COD_SETTLEMENT_PAGE");
      navigate("DENOMINATION_PAGE");
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
    },
  });

  const onValidate = (isCurrentSession, actionType) => {
    const payload = { locationId: locId };
    if (isCurrentSession) {
      payload.sessionId = localStorage.getItem("sessionId");
    }
    if (actionType === "DELETE_ALL_SESSION_HOLD_CARD") {
      payload.terminalName = licenseName;
    } else if (actionType === "DELETE_CURRENT_SESSION_HOLD_CARD") {
      payload.loggedInUserId = uidx;
    }
    deleteHoldCarts(payload);
  };

  const handleDeleteCart = (isCurrentSession, actionType) => {
    openAuthModal(() => onValidate(isCurrentSession, actionType), true);
  };

  return (
    <div className="chm-container">
      {renderAuthModal()}

      {/* Drawer renders via MUI portal above the modal */}
      <HoldOrderDrawer open={holdDrawerOpen} onClose={() => setHoldDrawerOpen(false)} />

      {/* Header */}
      <div className="chm-header">
        <div className="chm-icon-badge">
          <HourglassTopIcon sx={{ fontSize: 22, color: "#e65100" }} />
        </div>
        <div className="chm-header-text">
          <h2 className="chm-title">Hold Carts Found</h2>
          <p className="chm-subtitle">Review your hold carts before closing the session.</p>
        </div>
        <button className="chm-close-btn" onClick={() => setOpenHoldModal(false)}>
          <CloseIcon sx={{ fontSize: 18 }} />
        </button>
      </div>

      <div className="chm-divider-line" />

      {/* Body */}
      <div className="chm-body">
        <p className="chm-description">
          There are carts on hold. You can view and manage them, delete all hold carts, or skip and
          proceed to close the session.
        </p>

        <div className="chm-action-row" style={{ flexWrap: "wrap", justifyContent: "center" }}>
          <button className="chm-btn chm-btn--outline-blue" onClick={() => setHoldDrawerOpen(true)}>
            <EastIcon sx={{ fontSize: 15 }} />
            View Hold Carts
          </button>
          <button
            className="chm-btn chm-btn--outline-red"
            onClick={() => handleDeleteCart(true, "DELETE_CURRENT_SESSION_HOLD_CARD")}
            disabled={isDeletingHoldCart}
          >
            {isDeletingHoldCart ? (
              <CircularProgress size={14} sx={{ color: "#be123c" }} />
            ) : (
              <DeleteOutlineIcon sx={{ fontSize: 15 }} />
            )}
            Delete Current Session Hold
          </button>
          <button
            className="chm-btn chm-btn--outline-red"
            onClick={() => handleDeleteCart(false, "DELETE_ALL_SESSION_HOLD_CARD")}
            disabled={isDeletingHoldCart}
          >
            {isDeletingHoldCart ? (
              <CircularProgress size={14} sx={{ color: "#be123c" }} />
            ) : (
              <DeleteOutlineIcon sx={{ fontSize: 15 }} />
            )}
            Delete All Hold Carts
          </button>
        </div>

        <div className="chm-or-divider">
          <span className="chm-or-line" />
          <span className="chm-or-text">or</span>
          <span className="chm-or-line" />
        </div>

        <button
          className="chm-btn chm-btn--primary"
          onClick={() => {
            setOpenHoldModal(false);
            // navigate("COD_SETTLEMENT_PAGE");
            navigate("DENOMINATION_PAGE");
          }}
        >
          Proceed Anyway
          <EastIcon sx={{ fontSize: 15 }} />
        </button>
      </div>
    </div>
  );
};

export default ClosingHoldModal;
